/*=========================================================================================
  File Name: modulePermissionsMutations.js
  Description: Permissions Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	// Asigna los permisos al state
	SET_PERMISSIONS(state, permissions) {
		state.permissions = permissions;
	},
	// Asigna al state la relacion Rol-permiso
	SET_ROLE_PERMISSIONS(state, role_permissions) {
		state.role_permissions = role_permissions;
	},
	// Asigna los roles al state
	SET_ROLES(state, roles) {
		state.roles = roles;
	},
	// elimina el Permiso seleccionado del state
	REMOVE_PERMISSION(state, itemId) {
		const ItemIndex = state.permissions.findIndex((p) => p.id === itemId);
		state.permissions.splice(ItemIndex, 1);
	},
};
